import React, { useEffect, useRef, useState, SyntheticEvent } from "react";
import { observer } from "mobx-react";
import { init } from "echarts";
import { isEmpty, round } from "lodash";
import Color from "@/tool/color";
import UniversalTable from "./universal-table";
import Empty from "@/component/empty";
import moWelfare from "../store/wealfare";
import moIndex from "../../store";

interface IProps {}
interface IState {}

const WelfareProject = (props: IProps, state: IState) => {
  let echartdom: any = null;
  const topRef = useRef<any>(null);
  const { ProjectAdoptionDate, ProjectAdoptionList } = moWelfare;
  const { isMock } = moIndex;

  const getData = ProjectAdoptionDate?.map((res: any) => {
    const item: any = {};
    item.rate = res;
    return item;
  });

  const datas = ProjectAdoptionDate?.map((res: any) => {
    const item = res * 100;
    return item;
  });
  const render = () => {
    if (echartdom) echartdom.dispose();
    echartdom = init(topRef.current);
    const option = {
      tooltip: {
        trigger: "item",
        axisPointer: {
          // 坐标轴指示器，坐标轴触发有效
          type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
        },
        formatter: (parmes: any) => {
          const htl = `
                     <p style="font-family: 'Roboto';
                     color:${Color.blackColor(
                       1
                     )};font-size:14px;font-weight:500">${parmes.seriesName}</p>
                     <p style="margin-top:10px;display:flex;
                         justify-content: space-between;align-items: center;">
                      <span
                        style="display:inline-block;
                        width:10px;height:10px;
                        background:${Color.primary};
                        border-radius:50%;margin-right:5px">
                      </span>
                      <span style="font-family: 'Roboto';
                      color:${Color.blackColor(0.6)};font-size:12px">${
            parmes.name
          }</span>
                      <span style="margin:0 15px"></span>
                      <span style="font-family: 'Roboto';
                       color:${Color.blackColor(0.8)};font-size:14px">
                        ${round(parmes.value, 1)}%
                      </span>
                   </p>
                 `;
          return htl;
        },
      },
      legend: {
        data: [],
      },
      grid: {
        left: 20,
        right: "3%",
        bottom: 40,
        top: 30,
        containLabel: true,
      },
      yAxis: [
        {
          type: "value",
          splitLine: {
            show: true,
            lineStyle: {
              color: Color.blackColor(0.1),
              width: 1,
              type: "dashed",
            },
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: Color.ccc,
            },
          },
          axisTick: {
            show: true,
            lineStyle: {
              color: Color.ccc,
            },
          },
          axisLabel: {
            show: true,
            color: Color.blackColor(0.5),
            fontFamily: "Roboto",
            formatter: (val: any) => {
              return `${round(val, 1)} %`;
            },
          },
        },
      ],
      xAxis: [
        {
          type: "category",
          axisLine: {
            show: true,
            lineStyle: {
              color: Color.ccc,
            },
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            show: true,
            color: Color.blackColor(0.85),
            fontFamily: "Roboto",
          },
          data: ProjectAdoptionList,
        },
      ],
      series: [
        {
          name: "人均福利预算",
          type: "bar",
          label: {
            show: true,
            position: "top",
            fontFamily: "Roboto",
            fontSize: 14,
            formatter: (parmes: any) => {
              return `${round(parmes.value, 1)} %`;
            },
          },
          emphasis: {
            focus: "self",
            blurScope: "coordinateSystem",
          },
          color: Color.primary,
          lineStyle: {
            color: Color.primary,
            width: 2,
          },
          itemStyle: {
            borderRadius: [2, 2, 0, 0],
          },
          barWidth: 16,
          data: datas,
        },
      ],
    };
    echartdom.setOption(option);
  };

  useEffect(() => {
    if (!isEmpty(ProjectAdoptionDate)) {
      render();
    }
    window.addEventListener("resize", render);
    return () => {
      window.removeEventListener("resize", render);
    };
  }, [ProjectAdoptionList, ProjectAdoptionDate]);

  return (
    <section className="welfare-budget-hobby" id="welfareteam">
      <section>
        <span className="sub-title">福利项目采用情况</span>
      </section>
      <p className="two-title">
        采用某一福利项目的样本公司数量占全部样本公司数量的百分比
      </p>
      <p className="two-title">
        弹性福利：采购第三方弹性福利平台，员工通过积分兑换商品
      </p>
      <p className="two-title">
        礼包：采购生鲜综合礼包、百货综合礼包、食品综合礼包及跨大类综合礼包
      </p>

      {!isEmpty(ProjectAdoptionDate) ? (
        <section
          style={{
            padding: 20,
            background: Color.white,
            borderRadius: 8,
          }}
        >
          <section
            ref={topRef}
            style={{
              width: "100%",
              height: "270px",
              marginBottom: 20,
              backgroundImage: isMock
                ? "url(https://file.smartsalary.cn/web-img%402.0/market/image/ismock.png)"
                : "",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center center",
            }}
          />
          <UniversalTable
            labelList={["福利项目采用情况"]}
            legendList={ProjectAdoptionList}
            rateList={[{ data: getData }]}
          />
        </section>
      ) : (
        <Empty />
      )}
    </section>
  );
};

export default observer(WelfareProject);
